import React from 'react';
import Conversations from '@twilio/conversations';
import LoginForm from './LoginForm.js';
import ChatRooms from './chats/ChatRooms';
import ChatLog from './chats/ChatLog';
import ChatInput from './chats/ChatInput';
import { Redirect } from 'react-router-dom';
import axios from 'axios';
const queryString = require('query-string');


export const ChatContext = React.createContext();


function getZoom()
{
    var myParam = {topic: "Hello MOM"};

  axios.post("https://auxilliabackend.herokuapp.com/getMeetingNow",myParam)
  .then(function (response) {

    const data = response.data;
    console.log("response:")
    console.log(data);


  //window.location.reload(true);
  })
  .catch(function (error) {
    console.log("SOMETHING WENT WRONG");
    console.log(error);
  });
}




function Chatbot() {
  const [user, setUser] = React.useState({api: null, username: null, chatrooms: []});
  const [selectedChatroom, setSelectedChatroom] = React.useState(null);

  const chatData = {
    user: user,
    selectedChatroom: selectedChatroom,

    login: (_username, _classcode) => {
      //if student call /login-student in the flask with parameters identifier and classcode
      //if tutor call /login-tutor in the flask with parameters identifier and classcode
      //You should only local storage in this file for identifying between tutor
      document.body.style.cursor = 'progress';
      var myParam = {
        username: _username
      } 
      
      if(localStorage.getItem('mode') == 'tutor'){
        console.log("ITS A TUTOR");//axios.post("http://localhost:3000/login-tutor",myParam)
        return fetch('https://auxilliabackend.herokuapp.com/login-tutor', {
          method: 'POST',
          body: JSON.stringify({username: _username, classcode: _classcode})
        }).then(res => res.json()).then(data => {
          //!!IMPORTANT!! Don't get rid of this, it creates a conversation and sets user !!IMPORTANT!!
          Conversations.create(data.token).then(client => {
            document.body.style.cursor = 'default';
            setUser({
              api: client,
              username: _username,
              chatrooms: data.chatrooms,
            });
          });
        }).catch((error) => {
          document.body.style.cursor = 'default';
          throw error;
        });
      }
      if(localStorage.getItem('mode') == 'student'){
        return fetch('https://auxilliabackend.herokuapp.com/login-student', {
          method: 'POST',
          body: JSON.stringify({username: _username, classcode: _classcode})
        }).then(res => res.json()).then(data => {
          //!!IMPORTANT!! Don't get rid of this, it creates a conversation and sets user !!IMPORTANT!!
          Conversations.create(data.token).then(client => {
            document.body.style.cursor = 'default';
            setUser({
              api: client,
              username: _username,
              chatrooms: data.chatrooms,
            });
          });
        }).catch((error) => {
          document.body.style.cursor = 'default';
          throw error;
        });
      }
      
    },

    logout: () => {
      setUser({api: null, username: null, chatrooms: []});
      setSelectedChatroom(null);
    },

    selectChatroom: (sid) => {
      user.api.getConversationBySid(sid).then(conv => {
        setSelectedChatroom(conv);
      });  
    },
  }

  const sid = queryString.parse(window.location.search).id;
  var lclsid = localStorage.getItem('sessionID');
  if(sid == lclsid || localStorage.getItem('mode') == 'tutor')
  {
    return (
      <div className="App">
        <body className = "profileb">
        <h1>Chat</h1>
        <ChatContext.Provider value={chatData}>
          <LoginForm />
          {chatData.user.username !== null &&
            <div id="chat">
              <span class = "trying">
                
                <ChatRooms />
                <ChatLog />
                <div class = "messageboard">
                  <ChatInput />
                </div>
              </span>
            </div>
          }
        </ChatContext.Provider>
        {/* <button class = "zoomButton" onClick={() => {getZoom()}} value="hello"></button> */}
        </body>
      </div>
    );
  }
  else
  {
    return(
    <Redirect to="/404"></Redirect>
    );
  }
}

export default Chatbot;